import { setIconColor } from 'modules/utils/cssUtils';
import styled from 'styled-components';
import { BodyText, Flex, Label, Modal, theme } from '../../ui';
import { mediaQuery } from '../../utils';

export const DocumentListItem = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin: 0.75rem 0;

  h4 {
    margin-top: 0.1rem;
    color: ${({theme}) => theme.colors.primaryK7};
    :hover {
      color: ${({theme}) => theme.colors.primaryK10};
    }
  }

  svg {
    margin-right: 0.5rem;
    width: 1.2rem;
    height: 1.2rem;
  }
`;

export const DocumentationWrapper = styled(Flex)`
  ${mediaQuery('md')} {
    width: 37.5rem;
  }
`;

export const InvisibleInput = styled.input`
  display: none;
`;

export const UploadedFilesContainer = styled.div`
  overflow-y: auto;
  max-height: 7rem;
`;

export const FileContainer = styled.div`
  margin-top: 1.1rem;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  overflow-wrap: anywhere;

  h3 {
    color: ${({theme}) => theme.colors.primaryK7};
    margin-bottom: 0rem !important;
  }

  svg {
    margin-left: 0.4rem;
    width: 1.1rem;
    height: 1.1rem;
  }

  ${mediaQuery('md')} {
    width: fit-content;
  }
`;

export const ButtonContainer = styled(Flex)`
  & > button {
    width: 100%;
    margin-top: 1.1rem;
  }
`;

export const ResponsiveModal = styled(Modal).attrs({
  width: '45.438rem',
  height: '54rem',
})`
  min-width: 20rem;
  max-height: 80%;
  min-height: 25rem;
  overflow: scroll;
  background-color: ${({theme}) => theme.colors.primaryW};
  border: 1px solid ${theme.colors.primaryW};
`;

export const StyledUploadDiv = styled.div`
  font-weight: ${theme.fontWeight.bold};
  font-size: ${theme.fontSizes.body};
  padding: 0.3rem 1rem;
  border-radius: 4px;
  height: 3.125rem;
  min-height: 3.125rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background-color: ${({theme}) => theme.colors.primaryT2};
  color: ${({theme}) => theme.colors.primaryW};
  text-decoration: var(--text-underline);

  &:hover {
    border-color: ${({theme}) => theme.colors.primaryT1};
    background-color: ${({theme}) => theme.colors.primaryT1};
    cursor: pointer;
  }

  svg {
    height: ${({theme}) => theme.fontSizes.body};
    display: flex;
    align-items: center;
    justify-content: center;

    path {
      fill: ${({theme}) => theme.colors.primaryW};
    }
  }

  p {
    margin-right: 0.5rem;
  }

  ${mediaQuery('md')} {
    width: 24rem;
  }
`;

export const MobileUploadDiv = styled(Flex)`
  padding: 1rem 1rem 2rem 1rem;
  justify-content: space-evenly;
  align-items: center;
  background-color: ${({theme}) => theme.colors.primaryT4};
  border: 2px dashed ${({theme}) => theme.colors.primaryK3};
  transition: border-color 0.3s, background-color 0.3s;
  margin-top: 1.875rem;

  p {
    margin-bottom: 0;
  }

  h5,
  p {
    text-align: center;
  }
`;

export const StyledDragAndDrop = styled.label<{
  dragOver: boolean;
}>`
  padding: 1.5rem 1.5rem 1rem 1.5rem;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: center;
  background-color: ${({theme}) => theme.colors.primaryT6};
  border: 2px dashed ${({theme}) => theme.colors.primaryK3};
  transition: border-color 0.3s, background-color 0.3s;
  margin-top: 1.875rem;

  p {
    margin-bottom: 0;
  }

  h5,
  p {
    text-align: center;
  }

  ${mediaQuery('md')} {
    padding: 5.5rem 5.5rem 4rem 5.5rem;
    width: 100%;
    max-height: 24.175rem;
  }

  ${(props) =>
    props.dragOver
      ? `
      border-color: ${props.theme.colors.primaryT1};
      background-color: ${props.theme.colors.primaryT3};
      
      `
      : ''}
`;

export const TextWrapper = styled(Flex)`
  pointer-events: none;
  align-items: center;
  margin-bottom: 2rem;
`;

export const StyledLabel = styled(Label)`
  pointer-events: none;
  margin: 0.75rem 0;

  h4 {
    margin-top: 0.1rem;
    color: ${({theme}) => theme.colors.primaryK7};
    :hover {
      color: ${({theme}) => theme.colors.primaryK10};
    }
  }

  svg {
    margin-right: 0.5rem;
    width: 1.2rem;
    height: 1.2rem;
  }
`;

export const ErrorText = styled(Label)`
  margin: 1rem;

  svg {
    width: 1rem;
    height: 1rem;
    margin-bottom: -0.2rem;
    margin-right: 0.5rem;
  }
  ${({theme}) => setIconColor(theme.colors.primaryR5)};
`;

export const ModalError = styled.div<{
  hasError?: boolean;
}>`
  width: 100%;
  & > p {
    background-color: ${({theme}) => theme.colors.primaryR5};
    color: ${({theme}) => theme.colors.primaryW};
    padding: 0.563rem 0.625rem;
    user-select: none;

    font-weight: ${theme.fontWeight.thin};
    font-size: var(--main-font-size);
    line-height: var(--main-line-height);
    margin: 0;
  }
  opacity: 0;
  visibility: hidden;
  transition: all 0.15s linear;

  ${(props) => (props.hasError ? `opacity:1; visibility: visible;` : '')};
`;

export const StyledBodyText = styled(BodyText)`
  margin-bottom: 3rem;
`;

export const DateWrapper = styled.div`
  .ant-picker-dropdown {
    top: 70px !important;
  }
`;
